<template>
	<div class="home">
		<div class="header">
			<div class="header-title">数据报表</div>
		    <div class="header-select">
		    	<awesome-picker
			      	ref="selectPicker"
			      	:data="picker.data"
			      	:textTitle="picker.textTitle"
			      	:anchor="picker.anchor"
			      	@confirm="handleSelectHospital"
			    >
			    </awesome-picker>
			    <div class="select-wrapper" @click="selectShow">
			    	<span class="select">
			    		{{cuuentHospital}}
			    	</span>
			    	<span class="icon-wrapper">
			    		<i class="iconfont select-icon">&#xe61c;</i>
			    	</span>
		    	</div>
	        </div>
		</div>
		<div class="home-list-wrapper" ref="homeScroll">
			<ul class="home-list">
		        <router-link to="/register" tag="li" class="list-item">
		            <div class="item-head">
		                <span class="title">昨日数据</span>
										<router-link class="title-right"  :to="{name: 'DReport', params: {date: currentDates}}" tag="div">
											<span>日数据报表 ></span>
										</router-link>
		            </div>
		            <div class="item-content">
		                <div class="content-item">
		                    <p class="number">{{in_count}}</p>
		                    <p class="text">到诊</p>
		                </div>
		                <div class="content-item">
		                    <p class="number">{{dialog_count}}</p>
		                    <p class="text">对话</p>
		                </div>
										<div class="content-item">
		                    <p class="number">{{yester_sure_count}}</p>
		                    <p class="text">确诊对话</p>
		                </div>
		                <div class="content-item">
		                    <p class="number">{{cost_price}}</p>
		                    <p class="text">消费</p>
		                </div>
		            </div>
		        </router-link>
		        <router-link to="/detail" tag="li" class="list-item">
		            <div class="item-head">
		                <div class="title">{{currentDate}}月份</div>
		                <div class="budget">
		                	<i class="iconfont">&#xe6a4;</i>
		                	预算 <span class="col">{{cost_price_month}}</span>/{{total_order_price}}万
		                </div>
		                <div class="status">
		                    <span v-if="finish_num == 0">完成</span>
		                    <span v-if="finish_num > 0">{{finish_num}}</span>
		                    <span v-if="finish_num < 0">{{finish_num}}</span>
		                </div>
		            </div>
		            <div class="item-content">
		                <div class="content-item">
		                    <p class="number">{{in_count_month}}</p>
		                    <p class="desc">{{total_in_count}}</p>
		                    <p class="text">到诊</p>
		                </div>
		                <div class="content-item">
		                    <p class="number">{{dialog_count_month}}</p>
		                    <p class="desc">{{total_dialog_count}}</p>
		                    <p class="text">对话</p>
		                </div>
										<div class="content-item">
		                    <p class="number">{{sure_count}}</p>
		                    <p class="desc">{{total_sure_count}}</p>
		                    <p class="text">确诊对话</p>
		                </div>
										<div class="content-item">
		                    <p class="number">{{in_rate}} %</p>
		                    <p class="desc">{{total_in_rate}} %</p>
		                    <p class="text">到诊转化率</p>
		                </div>
		                 <div class="content-item">
		                    <p class="number">{{in_base}}</p>
		                    <p class="desc">{{total_in_base}}</p>
		                    <p class="text">到诊成本</p>
		                </div>
		                <div class="content-item">
		                    <p class="number">{{dialog_base}}</p>
		                    <p class="desc">{{total_dialog_base}}</p>
		                    <p class="text">对话成本</p>
		                </div>
										<div class="content-item">
		                    <p class="number">{{sure_base}}</p>
		                    <p class="desc">{{total_sure_base}}</p>
		                    <p class="text">确诊对话成本</p>
		                </div>
		            </div>
		        </router-link>
		    </ul>
		    <router-link :to="{ name:'InsertPlan',params: { type: 'insert'}}" tag="div" class="create-link" v-if="isShow">创建月任务</router-link>
		    <router-link to="/sets" tag="div" class="item-group" v-if="isAuthority"><button type="button" class="set-btn">权限设置</button></router-link>
	    </div>
	    <v-footer></v-footer>
	</div>
</template>

<script>
	import BScroll from 'better-scroll'
	import axios from 'axios'
	import {loadFromLocal,getCurrentTime,urlParse,getDay} from '@/assets/js/_mm.js'
	import VFooter from '@/pages/components/v-footer'
	export default {
		name: 'Home',
		data () {
			return {
				picker: {
					data: [],
					textTitle: '医院选择',
					anchor: []
				},
				hospId: '',
				currentDate: (() => {
				  return new Date().getMonth() + 1
				})(),
				currentDates: (() => {
				  return new Date().getFullYear() + '年' + (new Date().getMonth() + 1) + '月'
				})(),
				isShow: false,
				isAuthority: (() => {
					return this.$store.state.userInfo.unionid == '1k2DsQz8bRiiOpGhNaPHkIgiEiE' || this.$store.state.userInfo.unionid == 'yviiwdciPUdNN734gR4bnt3giEiE'? true : false
				})(),
				cuuentHospital: '',
				in_count: '', //昨日到诊量
				dialog_count: '', //昨日对话量
				yester_sure_count: '', // 确诊对话
				cost_price: '', // 昨日消费
				total_in_count: '', //计划月到诊量
				total_dialog_count: '', //计划月对话量
				total_dialog_base: '', //计划月对话成本
				total_sure_count: '', //计划确诊对话
				total_in_rate: '', // 计划月到诊转化率
				total_in_base: '', //计划月到诊成本
				total_sure_base: '', //计划月确诊对话成本
				total_order_price: '', //计划月消费
				cost_price_month: '', //实际月消费
				in_count_month: '', //实际月到诊量
				in_rate: '', // 实际到诊转化率
				dialog_count_month: '', //实际月对话量
				dialog_base: '', //实际月对话成本
				in_base: '', //实际月到诊成本
				sure_count: '', // 实际确诊对话
				sure_base: '', // 实际确诊对话成本
				finish_num: '' //月到诊完成量之差
			}
		},
		methods: {
			selectShow () {
				this.$refs.selectPicker.show()
			},
			handleSelectHospital (e) {
				this.cuuentHospital = e[0]['value']
				let hospId = this.picker['data'][e[0]['index']]['hos_id']
				this.picker['anchor'] = e
				this.$store.commit('changeHosp',{
					hospId: hospId,
					hospName: e[0]['value'],
					hospIndex: e[0]['index']
				})
				this._getHomeInfo()
			},
			_initHomeScroll () {
				this.nextTick(() => {
					this.homeScroll = new BScroll(this.$refs.homeScroll,{
						click: true,
						swipeBounceTime: 100
					})
				})
			},
			pickerAnchor () {
				if(this.$store.state.hospIndex) {
					this.picker.anchor = [
						{
							index: this.$store.state.hospIndex
						}
					]
				}
			},
			getHospInfo () {
				axios.get('/phal/public/',{
					params: {
						s: 'App.Report.Sel_hospital',
						sign: 1,
						userid : this.$store.state.userInfo.userid
					}
				}).then((res) => {
					let result = res.data
					let hospShow = ''
					if (result.ret && result.ret === 200) {
						let data = result.data
						data.forEach((item) => {
							item.value = item.hos_name
							this.picker.data.push(item)
							if(item.hos_id == this.$store.state.userInfo.hosid[0]) {
								hospShow = item.hos_name
							}
						}) 
						this.cuuentHospital = this.$store.state.hospName || hospShow || data[0]['hos_name']
					}

				})
			},
			_getHomeInfo () {
				axios.get('/phal/public/',{
					params: {
						s: 'App.Report.Sel_yesterday_msg',
						hos_id: this.$store.state.hospId || this.$store.state.userInfo.hosid[0],
						time: getDay(-1, '-')
					}
				}).then((res) => {
					let result = res.data
					if(result.ret && result.ret === 200) {
						let data = result.data
						this.in_count = data.in_count
						this.dialog_count = data.dialog_count
						this.yester_sure_count = data.sure_count
						this.cost_price = Math.round(data.cost_price)
					}
				})
				axios.get('/phal/public/',{
					params: {
						s: 'App.Report.Sel_current_month',
						hos_id: this.$store.state.hospId || this.$store.state.userInfo.hosid[0],
						time: getCurrentTime()
					}
				}).then((res) => {
					let result = res.data
					if(result.ret && result.ret === 200) {
						let data = result.data
						if(!data.total_dialog_base && !data.total_dialog_count && !data.total_in_base && !data.total_in_count && !data.total_order_price){
							this.isShow = true
						}else {
							this.isShow = false
						}
						let  totalOrderPrice = (data.total_order_price / 10000).toFixed(2)
						let  costPriceMonth = (data.cost_price / 10000).toFixed(2)
						let  dialogBase = Math.round(data.dialog_base)
						let  inBase = Math.round(data.in_base)
						this.total_in_count = data.total_in_count //计划月到诊量
						this.total_dialog_count = data.total_dialog_count //计划月对话量
						this.total_sure_count = data.total_sure_count // 计划确诊对话
						this.total_sure_base = Math.round(data.total_order_price / data.total_sure_count) // 计划确诊对话成本
						this.total_sure_base = this.total_sure_base == 'Infinity' ? data.sure_base : this.total_sure_base// 计划确诊对话成本
						this.total_in_rate = Math.round((data.total_in_count / data.total_dialog_count) * 100 ).toFixed(2) // 计划到诊转化率
						this.total_sure_base = isNaN(this.total_sure_base) ? '' : this.total_sure_base
						this.total_in_rate = isNaN(this.total_in_rate) ? 0 : this.total_in_rate
						this.total_dialog_base = data.total_dialog_base //计划月对话成本
						this.total_in_base = data.total_in_base //计划月到诊成本
						this.total_order_price = isNaN(totalOrderPrice) ? 0 : totalOrderPrice//计划月消费
						this.cost_price_month = isNaN(costPriceMonth) ? 0 : costPriceMonth //实际月消费
						this.in_count_month = data.in_count //实际月到诊量
						this.dialog_count_month = data.dialog_count //实际月对话量
						this.sure_count = data.sure_count // 实际确诊对话
						this.sure_base = Math.round(data.cost_price / data.sure_count) // 实际确诊对话成本
						this.sure_base = isNaN(this.sure_base) ? '' : this.sure_base
						this.sure_base = this.sure_base == 'Infinity' ? data.sure_base : this.sure_base // 实际确诊对话成本
						this.in_rate = (data.in_rate).toFixed(2);// 实际到诊转化率
						this.in_rate = isNaN(this.in_rate) ? 0 : this.in_rate
						this.dialog_base = dialogBase ? dialogBase :　0 //实际月对话成本
						this.in_base = inBase ? inBase : 0 //实际月到诊成本
						this.finish_num = data.finish_num //月到诊完成量之差
					}
				})
			}
		},
		components: {
			VFooter
		},
		mounted () {
			this._getHomeInfo()
			this.getHospInfo()
			this.pickerAnchor()
		}
	}
</script>

<style lang="stylus" scoped>
	.home .header
			display: flex
			justify-content: space-between
			height: 1.1rem
			padding: 0 .2rem 0 .4rem
			background-color: #fff
			.header-title
				line-height: 1.1rem
				color: #1d1d1d
				font-weight:bold
				font-size: .32rem
			.header-select
				.select-wrapper
					display: inline-block
					font-size: 0
					.select
						box-sizing: border-box
						display: inline-block
						vertical-align: top
						width: 1.48rem
						height: .58rem
						line-height: .58rem
						font-size: .28rem
						text-align: center
						border: 1px solid #666666
						border-right: none
					.icon-wrapper
						box-sizing: border-box
						display: inline-block
						vertical-align: top
						width: .48rem
						height: .58rem
						line-height: .58rem
						text-align: center
						border: 1px solid #666666
						.select-icon
							font-size: .28rem
		.home-list-wrapper
			position: absolute
			top: 1.1rem
			right: 0
			bottom: 1.24rem
			left: 0
			overflow: hidden
			background-color: #f2f2f2
			.home-list
				.list-item
					padding: 0 .4rem
					background-color: #ffffff
					&+.list-item
						margin-top: .28rem
						padding:5px 15px 15px 15px
					.item-head
						height: .8rem
						line-height: .8rem
						font-size: .26rem
						.title
							display: inline-block
							color: #666666
							font-weight:bold
						.title-right 
							float: right
							color: #09f
						.budget
							display: inline-block
							margin-left: .2rem
							color: #888
							margin-left:15px
							.col
								color:  #09f
								margin-left:10px;
						.status
							display: inline-block
							vertical-align: .04rem
							margin-left: .2rem
							float:right
							span
								display: inline-block
								width: 1rem
								height: .4rem
								line-height: .4rem
								color: #ffffff
								text-align: center
								border-radius: .2rem
								&:nth-child(1)
									border:1px solid #09f
									color:#09f
								&:nth-child(2)
									border:1px solid #66cc00
									color:#66cc00
								&:nth-child(3)
									border:1px solid #ff6600
									color:#ff6600
					.item-content
						display: flex
						flex-wrap: wrap
						padding:15px 0
						.content-item
							width: 1.65rem
							margin-bottom: .55rem
							text-align: center
							.number
								color: #0099ff
								font-size: .35rem
								margin-bottom: 8px
							.desc
								margin:8px 0 10px 0
								color: #888
								font-size: .28rem
							.text
								margin-top: .1rem
								color: #666
								font-size: 12px;
			.create-link
				width: 60%
				height: 1.24rem
				line-height: 1.24rem
				margin: .5rem auto
				color: #fff
				font-size: .42rem
				text-align: center
				border-radius: 6px
				background: #09f 
			.item-group
				text-align:center
				.set-btn
					background:#09f
					padding:10px 40px
					color:#fff
					border:none
					margin:20px auto
					border-radius:3px

</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue